<template>
  <label
    class="radio"
    :class="{'has-error': hasError}"
  >
    <span class="radio__content">
      <input
        class="radio__input"
        v-model="internalValue"
        :name="name"
        :disabled="disabled"
        :value="value"
        type="radio"
      >
      <span class="radio__marker"></span>
      <span
        class="radio__text"
        v-if="label && !$scopedSlots.label"
        v-html="label"
      ></span>
      <span
        class="radio__text"
        v-if="$scopedSlots.label"
      >
        <slot name="label"></slot>
      </span>
    </span>
  </label>
</template>

<script>
export default {
  name: 'Radio',
  model: {
    prop: 'inputModel'
  },
  props: {
    inputModel: {
      default: ''
    },
    label: String,
    name: String,
    value: {
      default: ''
    },
    disabled: Boolean,
    hasError: Boolean
  },
  computed: {
    internalValue: {
      get () {
        return this.inputModel
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
  $radio-border-color: map_get($color-neutral-black, 45);
  $radio-border-radius: 2px;

  .radio {
    display: inline-block;
    vertical-align: middle;
    @include text-md;
    font-weight: normal;
    user-select: none;
    padding-top: 8px;
    padding-bottom: 8px;
    max-width: 100%;

    &__content {
      display: flex;
      align-items: flex-start;
      position: relative;
      min-height: 24/16*1em;
    }

    &__input {
      opacity: 0;
      position: absolute;
      top: 0.15em;
      left: 0;
      width: 18px;
      height: 18px;
      margin: 0;
      z-index: 1;
      cursor: pointer;

      &[disabled] {

        &, & ~ * {
          cursor: not-allowed;
        }
      }
    }

    &__marker {
      flex: 0 0 auto;
      width: 18px;
      height: 18px;
      border: 1px solid $radio-border-color;
      border-radius: 50%;
      position: relative;
      top: 0.15em;
      cursor: pointer;
      color: $color-white;
      fill: $color-white;
      transition: $transition-default;

      &::before {
        content: "";
        position: absolute;
        top: -6px;
        left: -6px;
        right: -6px;
        bottom: -6px;
        border: 3px solid rgba($color-primary, 0.65);
        border-radius: 50%;
        opacity: 0;
        transition: $transition-default opacity;
      }

      &::after {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $color-primary;
        top: 50%;
        left: 50%;
        margin: -4px;
        transition: $transition-default opacity, $transition-default background-color;
        opacity: 0;
      }

      .radio:hover & {
        border-color: $color-primary;
      }

      .radio.has-error & {
        border-color: $color-danger;
      }

      .radio__input:focus ~ & {

        &::before {
          opacity: 1;
        }
      }

      .radio__input:checked ~ & {
        border-color: $color-primary;

        &::after {
          opacity: 1;
        }
      }

      .radio__input[disabled] ~ & {
        cursor: default;
        background-color: map-get($color-neutral-black, 4);
        color: map-get($color-neutral-black, 25);
        fill: map-get($color-neutral-black, 25);
        border-color: map-get($color-neutral-black, 15);

        &::after {
          background-color: map-get($color-neutral-black, 25);
        }
      }
    }

    &__text {
      padding-left: 12/16*1em;

      .radio__input[disabled] ~ & {
        color: map-get($color-neutral-black, 25);
      }
    }
  }
</style>
